// selectors/authSelectors.js

export const selectUser = (state) => state.auth.user;
export const selectAssociation = (state) => state.auth.association;
export const selectLocations = (state) => state.auth.association.location;
export const selectProfessionalProfile = (state) => state.auth.professionalProfile;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectAccessToken = (state) => state.auth.accessToken;
